import each from 'lodash/each';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import _ from 'lodash';

import { RespCodeList } from '../../../constants/customReport';

const getEntityIdForEntityType = entity => (
  entity.includes('Id') ? entity : `${entity.replace('s', '')}Id`
);
const getEntityNameForEntityType = entity => (
  entity.includes('Name') ? entity : `${entity.replace('s', '')}Name`
);
const getEntityMapNameForEntityType = entity => `${entity.replace('s', '')}Map`;

export const getBucketPermuteId = (bucket, entitiesStr) => {
  const idSeparator = '__';
  const ids = [];
  let entityId;
  if (!entitiesStr) {
    entityId = '1';
    ids.push(entityId);
  } else {
    const entities = entitiesStr.split(',');
    each(entities, (entity) => {
      entityId = bucket[getEntityIdForEntityType(entity)];
      if (entityId) { ids.push(entityId); }
    });
  }
  return ids.join(idSeparator);
};

export const getIdsWithPermuteId = (permuteId) => {
  const idSeparator = '__';
  return permuteId.split(idSeparator);
};

export const getNamesWithPermuteIdAndEntitiesMap = (permuteId, entitiesStr, entityIdMap) => {
  const idSeparator = '__';
  // return All APIs for special id
  if (permuteId === 1) {
    return ['All APIs'];
  }
  const ids = permuteId.split(idSeparator);
  const entities = entitiesStr.split(',');
  if (ids.length !== entities.length) {
    return ['Unknown'];
  }
  const names = [];
  each(ids, (id, idx) => {
    const entity = entities[idx];
    const entityTypeMap = entityIdMap[getEntityMapNameForEntityType(entity)];
    let entityName = (entityTypeMap && entityTypeMap[id]) || id;
    entityName = isEmpty(entityName) || isUndefined(entityName) ? 'Unauthorized' : entityName;
    names.push(entityName);
  });
  return names;
};

export const getBucketPermuteIdAndNames = (bucket, entitiesStr, entityIdMap) => {
  const idSeparator = '__';
  const ids = [];
  const names = [];
  let entityId;
  let entityName = '';
  let entityNameFromBucket = '';
  if (!entitiesStr) {
    entityId = '1';
    entityName = 'All APIs';
    ids.push(entityId);
    names.push(entityName);
  } else {
    const entities = entitiesStr.split(',');
    each(entities, (entity) => {
      entityId = bucket[getEntityIdForEntityType(entity)];
      entityNameFromBucket = bucket[getEntityNameForEntityType(entity)];
      if (entityId) { ids.push(entityId); }
      const entityTypeMap = entityIdMap[getEntityMapNameForEntityType(entity)];
      entityName = (entityTypeMap && entityTypeMap[entityId]) || entityNameFromBucket || entityId;
      entityName = isEmpty(entityName) || isUndefined(entityName) ? 'Unauthorized' : entityName;
      names.push(entityName);
    });
  }
  const permuteId = ids.join(idSeparator);
  return {
    permuteId,
    names,
    ids,
  };
};

export const getEntityPermuteMap = (dataBuckets, entitiesStr, entityIdMap) => {
  const entityPermuteMap = {};
  let permuteObject = {};
  let permuteId;
  if (!entitiesStr) {
    permuteObject = getBucketPermuteIdAndNames({}, entitiesStr, {});
    permuteId = permuteObject.permuteId;
    entityPermuteMap[permuteId] = {};
    entityPermuteMap[permuteId].ids = permuteObject.ids;
    entityPermuteMap[permuteId].names = permuteObject.names;
  } else {
    each(dataBuckets, (bucket) => {
      permuteObject = getBucketPermuteIdAndNames(bucket, entitiesStr, entityIdMap);
      permuteId = permuteObject.permuteId;
      entityPermuteMap[permuteId] = {};
      entityPermuteMap[permuteId].ids = permuteObject.ids;
      entityPermuteMap[permuteId].names = permuteObject.names;
    });
  }
  return entityPermuteMap;
};

const getEntityIdForEntityTypeForCustomReport = entity => entity;

const getEntityNameForEntityTypeForCustomReport = entity => (
  entity.includes('Name') ? entity : `${entity.replace('Id', '')}Name`
);

export const getSourcesIdsFromResponse = (response = {}, type, entitiesMap) => {
  const responseData = response || {};
  const data = responseData.data || {};
  const buckets = (data && data[type] && data[type].buckets) || [];
  const sourceIds = [];
  const entitiesStr = response && response.query && response.query.buckets;
  if (entitiesStr) {
    each(buckets, bucket => {
      const permuteObject = getBucketPermuteIdAndNames(bucket, entitiesStr, entitiesMap);
      sourceIds.push(permuteObject.permuteId);
    });
  } else {
    sourceIds.push('1');
  }
  return sourceIds;
};
const entityIdNameMap = {
  apiId: 'Api(s)',
  apiKeyId: 'API Key(s)',
  appId: 'Application(s)',
  orgId: 'Organization(s)',
  gatewayServerId: 'Proxy(s)',
  respCode: 'Response Code(s)',
  uri: 'URI(s)',
};

const getTooltipLabelForGroupedData = (entity, selectedDataSource, entityNameList) => {
  const filter = selectedDataSource.find(
    data => data.dimension === entity.split('-')[0],
  );
  const dimension = filter.dimension;
  const label = [];
  if (dimension === 'respCode') {
    const filterValues = _.keys(filter.values);
    if (filterValues.length) {
      label.push(filterValues.join(' ＋ '));
    } else if (filter.fields.length) {
      const name = [];
      filter.fields.forEach(field => {
        const range = `${field.lower}-${field.upper}`;
        name.push(RespCodeList[range].labelKey);
      });
      label.push(name.join(' ＋ '));
    }
  } else if (dimension === 'uri') {
    const filterValues = filter.values;
    const name = [];
    filterValues.forEach(value => name.push(value.name));
    label.push(name.join(' ＋ '));
  } else {
    const filterValues = _.keys(filter.values);
    const entityList = dimension.includes('Id')
      ? dimension.replace('Id', 'Map')
      : dimension;
    const names = [];
    const entityListMap = entityNameList[entityList];
    if (dimension === 'apiKeyId') {
      filterValues.forEach(item => {
        const apiKeyDetails = entityListMap[item];
        const { name, appName } = apiKeyDetails;
        let currentLabel = '';
        if (name && appName) {
          currentLabel = `${name} (${appName})`;
        } else {
          currentLabel = name || item;
        }
        names.push(currentLabel);
      });
    } else {
      filterValues.forEach(item => (_.keys(entityListMap).length ?
        names.push(entityListMap[item]) : names.push(item)));
    }
    label.push(names.join(' ＋ '));
  }
  return label;
};

export const getBucketPermuteIdAndNamesForCustomReport = (
  bucket,
  entitiesStr,
  selectedDataSource,
  entityNameList,
  ) => {
  const idSeparator = '__';
  const ids = [];
  const names = [];
  const tooltipLabel = [];
  let entityId;
  let entityName = '';
  let entityNameFromBucket = '';
  if (!entitiesStr) {
    entityId = '1';
    entityName = 'All APIs';
    ids.push(entityId);
    names.push(entityName);
  } else {
    const entities = entitiesStr.split(',');
    each(entities, (entity) => {
      entityId = entity.includes('-grouped') ?
        entity : bucket[getEntityIdForEntityTypeForCustomReport(entity)];
      entityNameFromBucket = entity.includes('-grouped') ?
        entity : bucket[getEntityNameForEntityTypeForCustomReport(entity)];
      if (entityId) { ids.push(entityId); }
      if (entity.includes('-grouped')) {
        entityName = entityIdNameMap[entity.split('-')[0]];
        const label = getTooltipLabelForGroupedData(
          entity, selectedDataSource, entityNameList);
        tooltipLabel.push(label);
      } else if (entity.includes('Id')) {
        if ((entity === 'apiKeyId') && entityId) {
          const apiKeyDetails = entityNameList.apiKeyMap[entityId];
          const { name, appName } = apiKeyDetails || {};
          if (name && appName) {
            entityName = `${name} (${appName})`;
          } else {
            entityName = name || entityNameFromBucket || entityId;
          }
        } else {
          entityName = bucket[entity.replace('Id', 'Name')] || entityNameFromBucket || entityId;
          entityName = isEmpty(entityName) || isUndefined(entityName) ? 'Unauthorized' : entityName;
        }
        tooltipLabel.push(entityName);
      } else {
        entityName = entityId;
        tooltipLabel.push(entityName);
      }
      entityName = isEmpty(entityName) || isUndefined(entityName) ? 'Unauthorized' : entityName;
      names.push(entityName);
    });
  }
  const permuteId = ids.join(idSeparator);
  return {
    permuteId,
    names,
    ids,
    tooltipLabel,
  };
};

export const getSourcesIdsFromResponseForCustomReport = (
  response = {},
  type,
  entitiesMap,
  selectedDataSource) => {
  const responseData = response || {};
  const sourceIds = [];
  const entitiesArray = [];
  selectedDataSource.forEach(dataSource => {
    if (dataSource.isGrouped) {
      const groupedDimension = `${dataSource.dimension}-grouped`;
      entitiesArray.push(groupedDimension);
    } else if (dataSource.type !== 'default') {
      entitiesArray.push(dataSource.dimension);
    }
  });
  const entitiesStr = entitiesArray.join(',');
  if (entitiesStr) {
    each(responseData, data => {
      const permuteObject = getBucketPermuteIdAndNamesForCustomReport(
        data, entitiesStr, selectedDataSource, entitiesMap,
      );
      sourceIds.push(permuteObject.permuteId);
    });
  } else {
    sourceIds.push('1');
  }
  return sourceIds;
};

export const getEntityNamesMapFromUsageResponse = (data = {}, entitiesStr) => {
  const idSeparator = '__';
  const entities = entitiesStr.split(',');
  const entityMap = {};
  if (data && data.usageTs) {
    each(data.usageTs, (bucket) => {
      if (bucket.usage && bucket.usage.length) {
        each(bucket.usage, (item) => {
          const ids = [];
          const names = [];
          each(entities, entity => {
            const entityId = getEntityIdForEntityType(entity);
            const entityName = getEntityNameForEntityType(entity);
            ids.push(item[entityId]);
            names.push(item[entityName]);
          });
          const id = ids.join(idSeparator);
          if (!entityMap[id]) {
            const hasInValidName = _.some(names, name => !name);
            if (!hasInValidName) {
              entityMap[id] = names;
            }
          }
        });
      }
    });
  }
  return entityMap;
};

export const getDefaultSharedMutations = (sourceIds, keyMetric) => {
  const sharedMutations = {};
  each(sourceIds, (permuteId) => {
    const defaultMetricVal = {
      show: true,
      hover: false,
    };
    sharedMutations[permuteId] = {
      show: true,
      metrics: {
        [keyMetric]: defaultMetricVal,
      },
    };
  });
  return sharedMutations;
};

const SOURCE_METRIC_SEPARATOR = '___';
export const getMetricKey = (id, metric) => `${id}${SOURCE_METRIC_SEPARATOR}${metric}`;
export const getSourceFromMetricKey = (metricKey) => metricKey.split(SOURCE_METRIC_SEPARATOR)[0];
export const getMetricFromMetricKey = (metricKey) =>
  ((metricKey.includes(SOURCE_METRIC_SEPARATOR) &&
    metricKey.split(SOURCE_METRIC_SEPARATOR)[1]) || '');
